import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const guestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const hasSsoParams = !!(route.queryParams['payload'] || route.queryParams['token']);

  if (authService.isAuthenticated() && !hasSsoParams) {
    // Already logged in, redirect to dashboard
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
